// src/Chat.tsx
import { useEffect, useState } from 'react';
import { Container, Button, Text, Group, rem } from '@mantine/core';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useCompanyInfo } from '@contexts/company-info';
import type { AssistantMessage } from '@src/types/assistant';
import DataError from '@components/data-error';
import { ChatMessages } from '@components/chat-messages';
import { useAssistant } from '@components/use-assistant';

function CompanyOverview() {
  const companyInfo = useCompanyInfo();
  const navigate = useNavigate();
  const location = useLocation();
  const { datasetId } = location.state;
  const [botResponse, setBotResponse] = useState<string>('');
  const [threadId, setThreadId] = useState<string | null>(null);
  // This is sending the initial message to the assistant, it must be in this format
  // TODO: this should be by type, etc, not a "special" message
  const [assistantMessage, setAssistantMessage] = useState<AssistantMessage>({
    message: JSON.stringify({
      website: companyInfo.company?.website,
      companyName: companyInfo.company?.name,
      datasetId: datasetId,
    }),
    threadId: null,
  });

  // TODO: maybe better to query the data vs use context, a refresh causes errors
  const { data, loading, error } = useAssistant(assistantMessage, { skip: !companyInfo.company });
  // TODO: loading should reflect the actual loading state, like the old dots, maybe a component that
  // display 20 dots and then restarts

  useEffect(() => {
    // drop data in initial data
    if (!data?.threadId) return;

    if (data?.threadId) {
      setThreadId(data.threadId);
    }

    // const botResponse: ChatMessage = {
    //   id: chatMessages.length + 1,
    //   text: `${data?.message || 'No AI response.'}`,
    //   isUser: false,
    // };
    setBotResponse(`${data?.message || 'No AI response. Please try again.'}`);
  }, [data]);

  useEffect(() => {
    if (!companyInfo.company) navigate('/get-started');
  }, [companyInfo.company, navigate]);

  // TODO: see note about query / if (!companyInfo.company) return <ErrorPageGeneral error={new Error('No company info found')} />;
  if (error) return <DataError error={error} />;
  return (
    <Container>
      {/* TODO <SubHeader /> */}
      <Text ta="center" p={rem(20)}>
        Based on your website <span style={{ fontWeight: 700 }}>{companyInfo.company?.website}</span> which
        you provided, we created this company overview for{' '}
        <span style={{ fontWeight: 700 }}>{companyInfo.company?.name}</span>.
      </Text>
      <Text ta="center" mb={rem(20)}>
        Please let me know of any changes you'd like to make.
      </Text>
      <ChatMessages
        setAssistantMessage={setAssistantMessage}
        assistantMessage={assistantMessage}
        threadId={threadId}
        loading={loading}
        loadingText="Building your company overview"
        botResponse={botResponse}
      />
      <Group justify="flex-end" pt={rem(40)} p={rem(0)} mb={rem(20)}>
        <Button variant="light" component={Link} to="/get-started">
          Back
        </Button>
        <Button component={Link} to="/okrs" state={{ threadId: threadId }} disabled={loading}>
          Next
        </Button>
      </Group>
    </Container>
  );
}

export { CompanyOverview };
